import React from 'react';
import {Text} from 'react-native';

import {Code, FlexView, Heading, Spacer} from '/component/base/Storybook';

import DefaultAvatar from '../DefaultAvatar';

export default () => (
  <>
    <Heading level={1}>Default Avatar</Heading>
    <Spacer size={16} />
    <Text>
      The <Code>{'<DefaultAvatar />'}</Code> component is used to render a
      randomized placeholder image when a user profile image is missing.
    </Text>
    <Spacer size={24} />
    <Heading level={2}>Variants</Heading>
    <Spacer size={16} />
    <Text>
      There are two variants of the <Code>{'<DefaultAvatar />'}</Code>{' '}
      component. By default, <Code>{'variant="client"'}</Code> will be rendered.
    </Text>
    <Spacer size={16} />
    <FlexView direction="horizontal">
      <FlexView align="center">
        <DefaultAvatar />
        <Spacer size={6} />
        <Text>
          <Code>{'variant="client"'}</Code>
        </Text>
      </FlexView>
      <Spacer direction="horizontal" size={16} />
      <FlexView align="center">
        <DefaultAvatar variant="coach" />
        <Spacer size={6} />
        <Text>
          <Code>{'variant="coach"'}</Code>
        </Text>
      </FlexView>
    </FlexView>
    <Spacer size={24} />
    <Heading level={2}>Size</Heading>
    <Spacer size={16} />
    <Text>
      The size of the avatar can be altered by specifying a value for the{' '}
      <Code>{'size'}</Code> prop.
    </Text>
    <Spacer size={16} />
    <FlexView direction="horizontal" align="end">
      <FlexView align="center">
        <DefaultAvatar size={24} />
        <Spacer size={6} />
        <Text>
          <Code>{'size={24}'}</Code>
        </Text>
      </FlexView>
      <Spacer direction="horizontal" size={16} />
      <FlexView align="center">
        <DefaultAvatar />
        <Spacer size={6} />
        <Text>
          <Code>{'size={40}'}</Code>
        </Text>
      </FlexView>
      <Spacer direction="horizontal" size={16} />
      <FlexView align="center">
        <DefaultAvatar size={64} />
        <Spacer size={6} />
        <Text>
          <Code>{'size={64}'}</Code>
        </Text>
      </FlexView>
    </FlexView>
    <Spacer size={24} />
    <Heading level={2}>Randomization</Heading>
    <Spacer size={16} />
    <Text>
      In order to seed the randomization, <Code>{'avatarKey'}</Code> needs to be
      supplied with a unique identifier for the user.
    </Text>
    <Spacer size={16} />
    <FlexView direction="horizontal">
      <FlexView align="center">
        <DefaultAvatar avatarKey="random.person@medifast.com" />
        <Spacer size={6} />
        <Text>
          <Code>{'avatarKey="random.person@medifast.com"'}</Code>
        </Text>
      </FlexView>
      <Spacer direction="horizontal" size={16} />
      <FlexView align="center">
        <DefaultAvatar avatarKey="a.coach@optavia.com" />
        <Spacer size={6} />
        <Text>
          <Code>{'avatarKey="a.coach@optavia.com"'}</Code>
        </Text>
      </FlexView>
    </FlexView>
  </>
);
